import Vue from "vue";
import VueRouter from "vue-router";
import App from "../App.vue";
import Greetings from "@/views/Greetings";
import Launcher from "@/views/Launcher";
import Backdrop from "@/views/Backdrop";
import OrderButton from "@/views/OrderButton";
import Preview from "../Preview.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      name: "app.preview",
      path: "/:slug/preview",
      component: Preview
    },
    {
      name: "app.index",
      redirect: { name: "app.launcher" },
      path: "/:slug/",
      component: App
    },
    {
      name: "app.order-button",
      path: "/:slug/order-button",
      component: OrderButton
    },
    {
      name: "app.greetings",
      path: "/:slug/greetings",
      component: Greetings
    },
    {
      name: "app.launcher",
      path: "/:slug/launcher",
      component: Launcher
    },
    {
      name: "app.backdrop",
      path: "/:slug/backdrop",
      component: Backdrop
    }
  ],
  mode: "history"
});

export default router;
